import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import { ExportToCsv } from "export-to-csv";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import axios from "axios";
import ReactModal from "react-modal";
import {
  GrupoAyB,
  GrupoAyBporInstitucion,
  documentacionPorSolicitud,
  obtenerDocumentacion,
} from "../../Services/Rest";
import Cookies from "universal-cookie";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Edit } from "@mui/icons-material";
import EditarVisita from "../Evaluador/EditarVisita";
import EditarDocumentacion from "../Modals/EditarDocumentacion";
import { FaFilePdf } from "react-icons/fa";
import EliminarAnexo from "./EliminaAnexos";

const cookie = new Cookies();

const InfoDocumentacionData = (props) => {
  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
  };
  const csvExporter = new ExportToCsv(csvOptions);
  const handleExportData = () => {
    csvExporter.generateCsv(list1);
  };
  const Example = () => {
    const handleExportRows = (rows) => {
      csvExporter.generateCsv(rows.map((row) => row.original));
    };

    const handleExportData = () => {
      csvExporter.generateCsv(list1);
    };
  };

  const urlA = obtenerDocumentacion;
  const urlU = documentacionPorSolicitud;

  const cookie = new Cookies();

  if (cookie.get("tipo_Usuario") == 1) {
    var urlendpoint = urlA;
  }
  if (cookie.get("tipo_Usuario") == 2) {
    var urlendpoint = urlU + cookie.get("institucionid");
  }
  if (cookie.get("tipo_Usuario") == 3) {
    var urlendpoint = urlA;
  }
  if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const grupos = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "A10"];
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
        filterVariant: "text",
      },
      {
        accessorKey: "estado",
        header: "Estado",
        filterVariant: "text",
      },
      {
        accessorKey: "sede",
        header: "Sede",
        filterVariant: "text",
      },
      {
        accessorKey: "fechaCorte",
        header: "Fecha Corte",
        filterVariant: "text",
      },
    ],
    []
  );
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  const [tableData, setTableData] = useState(() => list1);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    tableData[row.index] = values;
    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
  };
  const [rowSelection, setRowSelection] = useState([]);
  return (
    <div>
      <div className="container">
        <div className="text-left">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Documentos</h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <MaterialReactTable
                    columns={columns}
                    data={list1}
                    enableMultiRowSelection={true}
                    editingMode="modal"
                    enableColumnOrdering
                    enableEditing
                    onEditingRowSave={"handleSaveRowEdits"}
                    renderRowActions={({ row, table }) => (
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        {cookie.get("tipo_Usuario") == 1 ? (
                          <EditarDocumentacion id={row.getValue("id")} />
                        ) : (
                          <h></h>
                        )}

                        {row.getValue("estado") == "0" ? (
                          <EliminarAnexo id={row.getValue("id")} />
                        ) : (
                          <h></h>
                        )}
                      </Box>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoDocumentacionData;
